import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from 'actions/modalActions';
import * as optimizelyUtil from 'utils/optimizely';

import './BookFreeHotelAmendsLayout.desktop.scss';
import './BookFreeHotelAmendsLayout.mobile.scss';

const mapStateToProps = () => ({});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    toggleModalBound: bindActionCreators(toggleModal, dispatch),
  };
}

export class BookFreeHotelAmendsLayout extends Component {
  static propTypes = {
    toggleModalBound: PropTypes.func.isRequired,
  }


  close = () => {
    const { toggleModalBound } = this.props;

    toggleModalBound();
  }

  render() {
    optimizelyUtil.fireEvent('BookFreeHotelAmendsModal', 'displayed');

    return (
      <div className="book-free-hotel-amends-modal">
        <p>We understand that sometimes you need to make changes to your hotel booking. At loveholidays we want to give you maximum flexibility and great value so we will not charge you an admin fee to make any change to your accommodation.</p>
        <p>The only fee that you could be liable to is the cost difference between your current accommodation and your new one. All changes can be requested in the manage my booking section of the website.</p>
        <button onClick={this.close} className="book-free-hotel-amends-modal__close">Close</button>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookFreeHotelAmendsLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/BookFreeHotelAmendsLayout/BookFreeHotelAmendsLayout.jsx
 **/